import script from "./CoverageList.vue?vue&type=script&setup=true&lang=js"
export * from "./CoverageList.vue?vue&type=script&setup=true&lang=js"

import "./CoverageList.vue?vue&type=style&index=0&id=c16d7022&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c16d7022"]])

export default __exports__